import { handleDeleteRequest, handlePostRequest, handlePutRequest } from ".";
import { URI } from "../../constants/URI";

export const getAdvertisement = async (body = null) => {
    const res = await handlePostRequest(URI.advertisements, body, {
        toast: false,
        loading: false,
    });
    return res;
}

export const requestAdvertisementUpload = async (data) => {
    const res = await handlePostRequest(URI.advertisement_upload_request, data, {
        toast: false,
        loading: false,
    });
    return res;
}

export const completeAdvertisementUpload = async (data) => {
    const res = await handlePostRequest(URI.advertisement_upload_complete, data, {
        toast: false,
        loading: false,
    });
    return res;
}

export const deleteAdvertisement = async (body) => {
    const res = await handleDeleteRequest(URI.advertisement, body, {
        toast: false,
        loading: false,
    });
    return res;
}

export const updateAdvertisement = async (data) => {
    const res = await handlePutRequest(URI.advertisement, data, {
        toast: false,
        loading: false,
    });
    return res;
}

export const updateAdvertisementRanking = async (data) => {
    const res = await handlePutRequest(URI.advertisement_ranking, data, {
        toast: false,
        loading: false,
    });
    return res;
}
export const getManagedAdvertisements = async () => {
    const res = await handlePostRequest(URI.advertisements_all, null, {
        toast: false,
        loading: false,
    });
    return res;
}

export const previewAdvertisements = async (target) => {
    const res = await handlePostRequest(URI.advertisement_preview, target, {
        toast: false,
        loading: false,
    });
    return res;
}
